import React, { useEffect, useState } from "react";
import PersonAddAlt1Icon from "@mui/icons-material/PersonAddAlt1";
import { useNavigate } from "react-router-dom";
import Topbar from "../../../Component/Topbar/Topbar";
import { Table } from "../../../Component/Table/Table";
import { edit, search, view } from "../../../assets/img";
import { useForm, Controller } from "react-hook-form";
import Select from "react-select";
import SelectBox from "../../../Component/SelectBox";
import { get, post } from "../../redux/api/ApiHandler";
import { URLS } from "../../redux/api/Constants";
import useSearchFunction from "../../../Component/searchFunction";
import toast from "react-hot-toast";

const SuperAdmin = () => {
  const navigate = useNavigate();
  const [list, setList] = useState([]);
  const [page, setPage] = useState(1);
  const [superAdmin, setSuperAdmin] = useState();
  const [pagination, setPagination] = useState("");
  const [searchValue, setSearchValue] = useState("");
  const [selected, setSelected] = useState(null);

  const debounceval = useSearchFunction(searchValue);

  const fetchData = async (search) => {
    setSearchValue(search);
    const payload = {
      role: 1,
      search: search,
      page: page,
    };
    let res = await post(URLS.ADMINLIST, payload);
    if (res?.status == "success") {
      setList(res?.admins);
      setPagination(res?.pagination_meta);
    }
  };

  useEffect(() => {
    fetchData(debounceval);
  }, [debounceval, page]);

  const statusChange = async (id) => {
    console.log("id", id);
    const payload = {
      id: id,
    };
    let res = await post(URLS.ADMINSTATUS + id, payload);
    if (res?.status == "success") {
      toast.success(res?.message);
      fetchData();
    }
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "S.No",
        accessor: "page",
        Cell: ({ value, row }) => {
          return <p>{(page - 1) * 10 + row.index + 1}</p>;
        },
      },
      {
        Header: "Employee ID ",
        accessor: "code",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap ">{value}</p>;
        },
      },
      {
        Header: "Employee Name",
        accessor: "name",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap ">{value}</p>;
        },
      },
      {
        Header: "Email ID",
        accessor: "email",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap ">{value}</p>;
        },
      },
      {
        Header: "Mobile Number",
        accessor: "mobile",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap ">{value}</p>;
        },
      },
      {
        Header: "Role",
        accessor: "role",
        Cell: ({ value, row }) => {
          return (
            <p className="text-nowrap">
              {value == 1 ? "Super Admin" : "Admin"}
            </p>
          );
        },
      },
      {
        Header: "Status",
        accessor: "status",
        Cell: ({ value, row }) => (
          <div className="d-flex ac-jc mt-2">
            {row?.original?.mobile != 9876543210 && (
              <button
                onClick={() => statusChange(row.original.id)}
                className={`${
                  value === 0 ? "deactive-icon1" : "active-icon1"
                } f2 fs-xs-12 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-15  fs-xxl-16`}
              >
                {value === 0 ? "De-active" : "Active"}
              </button>
            )}
          </div>
        ),
      },
      {
        Header: "Actions",
        accessor: "",
        Cell: ({ value, row }) => {
          return (
            <React.Fragment>
              <div className="d-flex ac-jc mt-2 gap-3">
                <button
                  onClick={() => {
                    navigate("/super-admin-add", {
                      state: { type: "view", id: row?.original?.id },
                    });
                  }}
                  className="cust-btn "
                >
                  <img src={view} alt="" className=" editor-btn " />
                </button>

                {row?.original?.mobile != 9876543210 && (
                  <button
                    onClick={() => {
                      navigate("/super-admin-add", {
                        state: {
                          type: "edit",
                          id: row?.original?.id,
                          mobile: row?.original?.mobile,
                        },
                      });
                    }}
                    className="cust-btn "
                  >
                    <img src={edit} alt="" className=" editor-btn " />
                  </button>
                )}
              </div>
            </React.Fragment>
          );
        },
      },
    ],
    []
  );
  return (
    <>
      <Topbar header={"Super Admin"} />
      <div className="container_fluit1">
        <div className="d-flex ac-jb">
          <h4 className="f3 fs-sm-15 fs-md-19 fs-lg-20 fs-xl-22 fs-xxl-24">
            Total Employee : {pagination?.total}
          </h4>
          <button
            onClick={() =>
              navigate("/super-admin-add", { state: { type: "add" } })
            }
            className="Add_btn1 f2 fs-sm-15 fs-md-15 fs-lg-17 fs-xl-18 fs-xxl-20"
          >
            ADD
          </button>
        </div>
        <div className="d-flex ac-je gap-4">
          {/* <div className="col-md-2">
            <SelectBox selected={selected} setSelected={setSelected} />
          </div> */}

          <div className="search-input col-md-3 d-flex ac-jb my-4">
            <input
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
              type="text"
              placeholder="Search "
              style={{ border: "none", width: "200px" }}
              className="search-field f2 fs-sm-13 fs-md-15 fs-lg-16 fs-xl-18 fs-xxl-20"
            />
            <img src={search} className="search" />
          </div>
        </div>
        <Table
          columns={columns}
          setPageno={setPage}
          pagecount={pagination}
          data={list ?? []}
          show={true}
        />
      </div>
    </>
  );
};

export default SuperAdmin;
